import { addServiceRouteId } from '../../../data/booking/denormalizers/core';
import omit from 'lodash/omit';
import * as customerTypes from '../../../data/booking/constants/customer_types';
import isEmpty from "lodash/isEmpty";

function denormalizeItem(itemId, entities) {
    return entities.items[itemId];
}

function denormalizeService(serviceId, entities) {
    const service = entities.services[serviceId];
    let serviceData = addServiceRouteId(service);

    return {
        ...omit(serviceData, ['route', 'price', 'summary', 'line']),
        items: service.items.map(itemId => denormalizeItem(itemId, entities))
    };
}

const denormalize = (normalized) => {
    const { data, entities } = normalized;

    let denormalized = {
        comment: data.comment,
        services: data.services.map(serviceId => denormalizeService(serviceId, entities)),
        reference: data.reference
    };

    if (customerTypes.BUSINESS === data.customer.type) {
        denormalized = {
            ...denormalized,
            endUser: data.endUser,
            clientData : data.clientData
        };
    }

    return denormalized;
};

const denormalizeToUpdate = (normalized) => {
    const { data, entities } = normalized;

    let services = data.services.map(serviceId => denormalizeService(serviceId, entities))

    return {
        reference: data.reference,
        comment: data.comment,
        services: services.map(service => ({
            ...service,
            items: service.items.filter(item => !isEmpty(item.updateStatus))
        })).filter(service => service.items.length > 0)
    };
};

export {
    denormalize,
    denormalizeToUpdate
};
